<template>
  <el-dialog :title="title" :visible.sync="isShow" @close="close" :close-on-click-modal="false" :destroy-on-close="true" width="1300px">
    <div v-if="helpData.isSpecialPatient==1 && helpData.outlayType == '2' && helpData.specialPatientId" style="padding: 20px;">
      <especiallyDetail v-if="helpData.isSpecialPatient==1 && helpData.outlayType == '2' && helpData.specialPatientId" :specialPatientId="helpData.specialPatientId"></especiallyDetail>
    </div>
    <div v-else>
      <div v-if="dataMode == 'reset' && [0, 4].indexOf(helpData.apprStatus) > -1" style="text-align: right; padding: 0 16px 16px 0; background: white;">
        <el-button :loading="btnLoading" type="primary" icon="el-icon-s-release" size="small"
                  @click="saveData">暂存</el-button>
        <el-button :loading="btnLoading" type="primary" icon="el-icon-success" size="small"
                  @click="submitConfrim">提交</el-button>
      </div>
      <el-tabs v-model="activeName" >
        <el-tab-pane :label="helpData.reqMode == 1?'病历信息':'病历信息/家庭情况'" name="caseInfo">
          <div class="backed" v-if="(helpData.apprStatus == 3 || helpData.apprStatus == 4)">
            <img src="/static/err-icon.png" alt="" />
            <span class="back-title">{{ helpData.apprStatus==4?'退回':'拒绝' }}原因：</span>
            <span class="back-msg">{{ helpData.apprOpinion }}</span>
          </div>

          <dialogPanel>
            <HelpIdBar :helpId="helpData.helpId" :apprStatusText="helpData.apprStatus == 5 ? '审核中' : helpData.apprStatusText "></HelpIdBar>
            <div >
              <el-form :inline="true">
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="申请方式">
                      <el-input size="small" type="text" disabled v-model="helpData.reqModeText"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="注册时间">
                      <el-date-picker v-if="helpData.registerTime" size="small" type="date" disabled :value="helpData.registerTime">
                      </el-date-picker>
                      <el-input v-else size="small" type="text" disabled value="-"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="申请时间">
                      <el-date-picker v-if="helpData.submitTime" size="small" type="date" disabled :value="helpData.submitTime">
                      </el-date-picker>
                      <el-input v-else size="small" type="text" disabled value="-"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="登录方式">
                      <el-input size="small" type="text" disabled :value="helpData.reqMode == 1 ? (helpData.loginChannelText || '-') : '-'"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="6">
                    <el-form-item label="监护人电话" prop="guardPhone">
                      <el-input type="text" size="small" disabled :value="helpData.guardPhone || '-'" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="6">
                    <el-form-item label="其他电话" prop="guardOtherPhone">
                      <el-input type="text" size="small" disabled :value="helpData.guardOtherPhone || '-'" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="6">
                    <el-form-item label="监护人微信号" prop="guardWechat">
                      <el-input type="text" size="small" disabled :value="helpData.guardWechat || '-'" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="6">
                    <el-form-item label="常住地址" prop="liveAddr">
                      <el-input type="text" size="small" disabled :value="helpData.liveAddr || '-'" :title="helpData.liveAddr"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :md="6">
                    <el-form-item label="支付宝姓名" prop="loginUserName">
                      <el-input type="text" size="small" disabled  :value="helpData.loginUserName || '-'"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="6">
                    <el-form-item label="支付宝身份证" prop="loginIdNumber">
                      <el-input type="text" size="small" disabled  :value="helpData.loginIdNumber || '-'"></el-input>
                    </el-form-item>
                  </el-col>
<!--                  <el-col :md="6" v-if="xiangqing == 'xiangqing'">-->
                  <el-col :md="6">
                    <el-form-item label="支付宝UID" prop="loginUserId">
<!--                   <el-input  type="text" size="small" disabled  :value="helpData.OpenIdAli || '-'"></el-input>-->
                      <el-input  type="text" size="small" disabled  :value="helpData.loginChannelText=='支付宝' ? (helpData.OpenIdAli || '-') : '-'"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="6">
                    <el-form-item label="与患儿关系">
                      <el-input type="text" size="small" disabled  :value="helpData.loginRelationText || '-'"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
	              <el-row>
		              <el-col :md="6">
			              <el-form-item label="住院号">
				              <el-input type="text" size="small" disabled  :value="helpData.inHospitalNo || '-'"></el-input>
			              </el-form-item>
		              </el-col>
		              <el-col :md="6" v-if="helpData.isShowInHospitalTime == 1">
			              <el-form-item label="入院时间">
				              <el-date-picker v-if="helpData.inHospitalTime" size="small" type="date" disabled :value="helpData.inHospitalTime">
				              </el-date-picker>
				              <el-input v-else size="small" type="text" disabled value="-"></el-input>
			              </el-form-item>
		              </el-col>
                  <el-col :md="6" v-if="helpData.isShowInHospitalTime == 1">
                    <el-form-item label="住院流水号">
                      <el-input type="text" size="small" disabled  :value="helpData.inHospitalSerialNo || '-'"></el-input>
                    </el-form-item>
                  </el-col>
	              </el-row>
              </el-form>
            </div>
          </dialogPanel>
          <el-collapse v-model="activeNames" >
            <MyCollapse title="病历信息"  iconPath="/static/de-zmr.png"  name="1">
              <ChildCase
                ref="caseInfo"
                :dataMode="dataMode"
                :readOnly="dataMode != 'reset' || !(helpData.apprStatus == 4 && helpData.curStages > 1)"
                :helpReqId="helpData.helpReqId"
                :helpId="helpData.helpId"
                :belongProject="helpData.initialProject">
              </ChildCase>
              <el-form :model="helpData" :inline="true">
                <el-form-item v-if="helpData.reqMode == '1' && helpData.apprStatus == 2" label="术后照片">
                  <FileUpload v-model="helpData.recoveryAttachIds" :disabled="false"></FileUpload>
                </el-form-item>
              </el-form>
            </MyCollapse>
            <MyCollapse title="附件"   iconPath="/static/de-att.png" v-if="helpData.reqMode == '2'" name="2">
              <div>
                <el-form :model="helpData" :inline="true">
                  <el-form-item label="相关证明附件">
                    <FileUpload v-model="helpData.proxyAttachIds" :disabled="true"></FileUpload>
                  </el-form-item>
                  <el-form-item v-if="helpData.apprStatus == 2" label="术后照片">
                    <FileUpload v-model="helpData.recoveryAttachIds" :disabled="false"></FileUpload>
                  </el-form-item>
                </el-form>
              </div>
            </MyCollapse>
          </el-collapse>


        </el-tab-pane>
        <el-tab-pane v-if="helpData.reqMode == 1" label="家庭情况" name="familyInfo">
          <div  class="backed" v-if="helpData.reqMode == '1'&&(helpData.apprStatus == 3 || helpData.apprStatus == 4)">
            <img src="/static/err-icon.png" alt="" />
            <span class="back-title">{{ helpData.apprStatus==4?'退回':'拒绝' }}原因：</span>
            <span class="back-msg">{{ helpData.apprOpinion }}</span>
          </div>
          <ChildFamily v-if="activeName == 'familyInfo'" :helpData="helpData"></ChildFamily>
        </el-tab-pane>
        <el-tab-pane label="审核记录" name="auditHistory">
          <ChildHistory
            :helpId="helpData.helpId"
            :outlayId="helpData.outlayId"
            :protocolId="helpData.protocolId">
          </ChildHistory>
        </el-tab-pane>
      </el-tabs>
      <div v-if="activeName == 'caseInfo' && helpData.apprStatus == 2" slot="footer" class="dialog-footer" style="text-align: center; background: white; padding: 16px;">
        <el-button :loading="loading" @click="close">取消</el-button>
        <el-button :loading="loading" type="primary" @click="saveRecoveryAttach">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  getRequestAttachInfo,
  getCaseAttachCaseAttachInfo,
  childCaseSave,
  getRequestLabels,
  saveRequestApi,
  sbumitRequestApi,
  saveProxyRequest,
  sbumitProxyRequest,
  getHelpRequestDataById,
} from "@/util/api";

import ChapterHead from "@/components/business/ChapterHead";
import HelpIdBar from "@/components/business/HelpIdBar";
import FileUpload from "@/components/business/FileUpload";
import ChildFamily from './ChildFamily'
import ChildCase from './ChildCase'
import ChildHistory from './ChildHistory'
import especiallyDetail from '@/pages/special/manage/especiallyDetail'
import CureOutlayDetail from '@/pages/outlay/cure/CureOutlayDetail'
import CheckOutlayDetail from '@/pages/outlay/check/CheckOutlayDetail'
import dialogPanel from "@/components/business/dialogPanel";
import MyCollapse from "@/components/business/MyCollapse";
export default {
  components: {
    ChapterHead,
    HelpIdBar,
    FileUpload,
    dialogPanel,
    ChildFamily,
    ChildCase,
    ChildHistory,
    especiallyDetail,
    CheckOutlayDetail,
    CureOutlayDetail,
    MyCollapse,
  },
  props: {
    visible: false,
    dataMode: {
      type: String,
      default: 'view'
    },
    helpData: {
      type: Object,
      default () {
        return {}
      }
    },
    title:{
      type:String,
      default:'救助申请详情'
    },
 /*   xiangqing: {
      type:String,
      default:""
    }*/
  },
  watch: {
    visible() {
      this.isShow = this.visible;
    },
  },
  data () {
    return {
      currentHospital: {},
      btnLoading: false,
      loading: false,
      activeNames:['1','2'],
      isShow:this.visible,
      labelsList:[],
      activeName: 'caseInfo'
    }
  },
  mounted () {
    this.loadData();
  },
  created() {
    this.getRequestLabels()
  },
  methods: {
    getRequestLabels(){
      getHelpRequestDataById({helpReqId:this.helpData.helpReqId}).then(res=>{
        if(res.msgCode==200){
          this.$set(this.helpData,'isAlipay',res.responseData.isAlipay);
          this.$set(this.helpData,'liveAddr',res.responseData.liveAddr);
          this.$set(this.helpData,'loginUserName',res.responseData.loginUserName);
          this.$set(this.helpData,'loginIdNumber',res.responseData.loginIdNumber);
          this.$set(this.helpData,'OpenIdAli',res.responseData.OpenIdAli);
          this.$set(this.helpData,'loginRelation',res.responseData.loginRelation);
          this.$set(this.helpData,'loginRelationText',res.responseData.loginRelationText);
          this.$set(this.helpData,'isShowInHospitalTime',res.responseData.isShowInHospitalTime);
        }
      });
      getRequestLabels({helpReqId:this.helpData.helpReqId}).then(res=>{
        console.log(res)
        if(res.msgCode==200){
          this.labelsList = res.responseData
        }
      })
    },
    loadData () {
      if (this.helpData.reqMode == '2') {
        getRequestAttachInfo({
          helpReqId: this.helpData.helpReqId,
          attachType: '1'
        }).then(res => {
          if (res.msgCode == 200 && res.responseData.length > 0) {
            let proxyAttachIds = res.responseData.map(d => {
              return d.attachId;
            });
            this.$set(this.helpData, 'proxyAttachIds', proxyAttachIds)
          }
        });
      }
      getCaseAttachCaseAttachInfo({
        helpReqId: this.helpData.helpReqId,
        helpId: this.helpData.helpId,
        attachType: '31'
      }).then(res => {
        if (res.msgCode == 200 && res.responseData.length > 0) {
          let recoveryAttachIds = res.responseData.map(d => {
            return d.attachId;
          });
          this.$set(this.helpData, 'recoveryAttachIds', recoveryAttachIds)
        }
      });
    },
    saveRecoveryAttach () {
      let attachList = this.helpData.recoveryAttachIds ? this.helpData.recoveryAttachIds.map(id => {
        return {
          attachType: '31',
          attachId: id
        }
      }) : [];
      this.loading = true;
      childCaseSave({
        helpId: this.helpData.helpId,
        postoperaInfoList: attachList
      }).then(res => {
        this.loading = false;
        if (res.msgCode == 200) {
          this.$message.success('保存成功！');
          this.close()
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    saveData () {
      let params = this.$refs.caseInfo.getFormData() || {};
      let req = null;
      if (this.helpData.reqMode == '1') {
        req = saveRequestApi({
          childUid: this.helpData.childUid,
          helpReqId: this.helpData.helpReqId,
          helpId: this.helpData.helpId,
          resubmitFlag: 1,
          proxyCaseInfo: {
            preoperaBUltraList: params.attachList
          }
        });
      } else {
        req = saveProxyRequest({
          childUid: this.helpData.childUid,
          helpReqId: this.helpData.helpReqId,
          helpId: this.helpData.helpId,
          resubmitFlag: 1,
          proxyCaseInfo: {
            preoperaBUltraList: params.attachList
          }
        });
      }
      this.btnLoading = true;
      req.then(res => {
        this.btnLoading = false;
        if (res.msgCode == 200) {
          this.$message.success('保存成功！');
          this.$emit('success');
          this.close()
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    submitConfrim () {
      let params = this.$refs.caseInfo.getFormData() || {};
      let req = null;
      if (this.helpData.reqMode == '1') {
        req = sbumitRequestApi({
          childUid: this.helpData.childUid,
          helpReqId: this.helpData.helpReqId,
          helpId: this.helpData.helpId,
          resubmitFlag: 1,
          proxyCaseInfo: {
            preoperaBUltraList: params.attachList
          }
        });
      } else {
        req = sbumitProxyRequest({
          childUid: this.helpData.childUid,
          helpReqId: this.helpData.helpReqId,
          helpId: this.helpData.helpId,
          resubmitFlag: 1,
          proxyCaseInfo: {
            preoperaBUltraList: params.attachList
          }
        });
      }
      this.btnLoading = true;
      req.then(res => {
        this.btnLoading = false;
        if (res.msgCode == 200) {
          this.$message.success('提交成功！');
          this.$emit('success');
          this.close()
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    close () {
      this.helpData.recoveryAttachIds = [];
      this.helpData.proxyAttachIds = [];
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/common/dialog";
@import "src/common/form";
</style>



// WEBPACK FOOTER //
// src/pages/child/view/HelpDetailDialog.vue